export class Refresh {
  public static readonly type = '[Notifications] Refresh';
}
